/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: searchform.js
 */
$.namespace("SCS.search");

SCS.search.isAjaxRequest = false;
SCS.search.searchKeywordDefaultText = "";
SCS.search.subCategoryDefaultText = "";
SCS.search.EMPTY_SEARCH_TERM = "_";

SCS.search.setI18nEntries = function(searchInstructionI18n,subCategoryI18n) {
	SCS.search.searchKeywordDefaultText = searchInstructionI18n;
	SCS.search.subCategoryDefaultText = subCategoryI18n;
};

SCS.search.initSearchBox = function() {
	var helpTextElement = $("#helpText");
	var helpTextVal = helpTextElement.val();

	var searchBoxElement = $("#search");
	var searchBoxVal = searchBoxElement.val();

	if(helpTextVal != searchBoxVal) {
		searchBoxElement.addClass('active');
	}
};

SCS.search.setSearchBox = function(isOnfocusEvent) {

	var helpTextElement = $("#helpText");
	var helpTextVal = helpTextElement.val();
	
	var searchBoxElement = $("#search");
	var searchBoxVal = searchBoxElement.val();
	
	if (isOnfocusEvent) {
	
		if (helpTextVal == searchBoxVal) {
			searchBoxElement.val('');
		}
		searchBoxElement.addClass('active');
	}

	//Handle EMPTY_VALUE placeholder '_'
	else {
		if (searchBoxVal == ''||searchBoxVal == SCS.search.EMPTY_SEARCH_TERM) {
			searchBoxElement.val(helpTextVal);
		}
		searchBoxElement.removeClass('active');
	}

};

SCS.search.populateSubTags = function () {
	var json = $("#scs-search-data").find("#tags").data("value");

	// category tag selected by user
	var categoryTagValue = $("#categoryTag").val();

	var subCategoryTag = json.tags[categoryTagValue];

	$('#subcategoryTags').empty();
	var subCategoryDropDown = '';
	var subCategoryTagInRequest = $("#subCat").val();
	subCategoryDropDown += '<select name="sc" id="subtagDropdown" class="customDropDown">';

	var labelCat = $("#categoryTag option:selected").text();

	if(categoryTagValue === "" ) {
		labelCat = "";
	}

	var textX = SCS.search.subCategoryDefaultText.replace("{0}",labelCat);

	subCategoryDropDown += '<option value="">'+textX+'</option>';
	var id = "";
	var title ="";

	if(categoryTagValue === "") {
		$('#subcategoryTags').addClass("disabledropdown");
	}
	else {
		$('#subcategoryTags').removeClass("disabledropdown");
	}
	for (var subCategoryTagKey in subCategoryTag) {
		if(subCategoryTag.hasOwnProperty(subCategoryTagKey)){
			id = subCategoryTag[subCategoryTagKey].id;
			title = subCategoryTag[subCategoryTagKey].title;
			if(subCategoryTagInRequest == id) {
				subCategoryDropDown += '<option value=\"'+id+'\" selected>'+title+'</option>';
			}
			else {
				subCategoryDropDown += '<option value=\"'+id+'\">'+title+'</option>';
			}
		}
	}
	subCategoryDropDown += '</select>';
	$('#subcategoryTags').html(subCategoryDropDown);
	$('#subtagDropdown').sSelect();
};

SCS.search.sendRequest = function() {

	var keyword = SCS.search.clean($("#search").val());
	if (this.isAjaxRequest) {
		return;
	}
	if(keyword == SCS.search.searchKeywordDefaultText ) {
		keyword = "";
	}

	window.location.href = SCS.search.buildUrl(keyword);
	SCS.supportstrip.loadStrips();
	return false;
};

SCS.search.sendRequestSuggestedKeyword = function() {
	var keyword = $("#suggestedKeyword").val();
	window.location.href = SCS.search.buildUrl(keyword);
};

SCS.search.filterEmptyTerms = function (term) {
	
	//empty suffixes are replaced by _ to work around Nevis configurations that can delete "//" under some circumstances.
	
	if (term == SCS.search.EMPTY_SEARCH_TERM) {
		return '';
	}
	return term;
}

SCS.search.encodeEmptyTerms = function (term) {
	
	//empty suffixes are replaced by _ to work around Nevis configurations that can delete "//" under some circumstances.
	
	if (term == '') {
		return SCS.search.EMPTY_SEARCH_TERM;
	}
	return term;
}

SCS.search.buildUrl = function(keyword) {

	var category = $("#categoryTag").val() || "";
	var subcategory = $("#subtagDropdown").val() || "";
	keyword = jQuery.trim(keyword);

	keyword = keyword.replace(/\./g, " ");
	subcategory = subcategory.replace(/\//g, ":");
	
	keyword = SCS.search.encodeEmptyTerms(keyword);
	category = SCS.search.encodeEmptyTerms(category);
	subcategory = SCS.search.encodeEmptyTerms(subcategory);

	var suffixes = "/" + keyword + "/" + category + "/" + subcategory;

	var url = $("#searchForm").attr('action');

	if (!!("ontouchend" in window)) {
		return url + ".mobile.html" + suffixes;
	}else {
		return url + ".html" + suffixes;
	}
};

SCS.search.init = function() {

	SCS.search.initSearchBox();

	$(document).on("searchEvent", function(event, pathname) {

		pathname = decodeURIComponent(pathname);
		
		//query parameters and the hash are not part of the pathname
		var pathnameSplit = pathname.split('.html');

		if (pathnameSplit.length>1) {
			suffixPart = pathnameSplit[1];
		} else {
			return;
		}

		suffixes = suffixPart.split('/');

		if (suffixes.length == 4) {

			//this is a proper selector structure for the help search

			var keyword = SCS.search.filterEmptyTerms(suffixes[1]);
			var category = SCS.search.filterEmptyTerms(suffixes[2]);
			var subCategory = SCS.search.filterEmptyTerms(suffixes[3]);

			$("#search").val(keyword);

			$("#categoryTag").val(category);
			$("#categoryTag").trigger("change.sSelect");

			SCS.search.populateSubTags();
			subCategory = subCategory.replace(category+":",category+"/");
			$("#subtagDropdown").val(subCategory);
			$("#subtagDropdown").trigger("change.sSelect");

		}

	});

	var pathname = SCS.search.clean(decodeURIComponent(escape(location.pathname)));
	$(document).trigger("searchEvent",[pathname]);
	if (!!SCS.header && typeof SCS.header.changeheaderurl == 'function'){
	SCS.header.changeheaderurl("de");
	SCS.header.changeheaderurl("en");
	SCS.header.changeheaderurl("fr");
	SCS.header.changeheaderurl("it");
	}
};

// strip the following characters: backslash
SCS.search.clean = function(s) {
	return s.replace(/\\/g,'');
};

$(document).ready(function(){
	var $data = $("#scs-search-data");
	if ($data.length === 0) return;
	
	$(".searchform #search").on('keypress', function(e) {
		if(e.keyCode == 13){
			SCS.search.sendRequest();
			return false;
		}
		return true;
	});

	$("#searchForm").submit(function(event) {
		SCS.search.sendRequest();
		event.preventDefault();
	});

	SCS.search.setI18nEntries(
		$data.find("#searchKeywordDefaultText").data("value"),
		$data.find("#subCategoryDefaultText").data("value")
	);
	SCS.search.init();
	SCS.search.setSearchBox(false);

	if (!!SCS.searchsuggestion) {
		if ($data.find("#showsuggestion").data("value")) {
				  SCS.searchsuggestion.init($data.find("#path").data("value"));
		}
	}



	SCS.search.populateSubTags();
});



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/help/clientlibs/desktop/js/searchform.js
// module id = 337
// module chunks = 0